module.exports = __webpack_public_path__ + "img/certification.4d686750.svg";